import {
  GET_FINANCICAL_SCHEMAS,
  SET_FINANCICAL_SCHEMAS_TEMPLATES,
  GET_FINANCICAL_SCHEMAS_TEMPLATES,
  GET_FINANCICAL_SCHEMA_BY_ID,
  NEM_FIN_STR_CREATING_STATUS,
  SET_DEALROOM_FIN_ERRORS_OBJ_CREATING,
  EMPTY_FIN_STRUCTURE, SET_FIN_ERROR, EMPTY_FIN_ERROR, SET_DEALROOM_FIN_ERRORS
} from "./../actions/types";
import {SET_FIN_ERRORS_NULL} from "../actions/types";

export default function (state = {}, action) {
  switch (action.type) {
    case GET_FINANCICAL_SCHEMAS:
      return {...state, ...action.payload};
    case NEM_FIN_STR_CREATING_STATUS:
      return {...state, finschemaCreate: action.payload};
    case SET_FINANCICAL_SCHEMAS_TEMPLATES:
      return {...state, financicalSchemasTemplates: action.payload};
    case GET_FINANCICAL_SCHEMAS_TEMPLATES:
      return {...state, ...action.payload};
    case GET_FINANCICAL_SCHEMA_BY_ID:
      return {...state, finSchema: action.payload,dealroomFinSchemaErrors:null,finSchemaErrors:{}};
    case EMPTY_FIN_STRUCTURE:
      return {...state, finSchema: null};
    case SET_FIN_ERROR:
      let errors = state.finSchemaErrors;
      const {error, field} = action.payload;
      errors[field] = error;
      return {...state, finSchemaErrors: errors};
    case SET_DEALROOM_FIN_ERRORS:
      let dealroomFinSchemaErrors = state.dealroomFinSchemaErrors;
      const {payload} = action;
      dealroomFinSchemaErrors[payload.index][payload.field] = payload.error;
      return {...state, dealroomFinSchemaErrors};
    case SET_DEALROOM_FIN_ERRORS_OBJ_CREATING:
      let arrOfErrorObjects = [];
      for (let i = 0; i < action.payload; i++) {
        arrOfErrorObjects.push({});
      }
      return {...state, dealroomFinSchemaErrors: arrOfErrorObjects,finSchemaErrors:null};
    case SET_FIN_ERRORS_NULL:
      return {...state,finSchemaErrors:null};

    case EMPTY_FIN_ERROR:
      return {...state, finSchemaErrors: {},dealroomFinSchemaErrors:null};
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/financicalSchemas.js